import { ChangeEvent, KeyboardEvent, useState } from 'react'
import { useNavigate } from 'react-router'

import Button from '@mui/material/Button'
import Input from '@/components/_legacy/Input'
import { TitleSetter } from '@/components/Title'

export const EventsView = () => {
  const navigate = useNavigate()
  const [submitting, setSubmitting] = useState(false)
  const [eventId, setEventId] = useState<string>('')

  const viewEvent = () => {
    setSubmitting(true)
    try {
      navigate('/event/' + eventId)
    } finally {
      setSubmitting(false)
    }
  }

  const onChange = (event: ChangeEvent<HTMLInputElement>) => {
    const {
      target: { value }
    } = event
    setEventId(value)
  }

  const onKeyDown = (event: KeyboardEvent) => {
    if (event.key === 'Enter') {
      viewEvent()
    }
  }

  return (
    <>
      <TitleSetter title="Event" />
      <div
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          textAlign: 'center',
          padding: '0 30%'
        }}
      >
        <h4>Input an event id</h4>
        <Input
          sx={{ background: 'white', my: 2 }}
          value={eventId}
          onChange={onChange}
          onKeyDown={onKeyDown}
        />
        <Button disabled={!eventId || submitting} variant="contained" onClick={viewEvent}>
          View Event
        </Button>
      </div>
    </>
  )
}
